import { mapState, mapActions } from 'vuex';

export default {
  computed: {
    ...mapState('models/conceptPaymentTypes', ['conceptPaymentTypes']),
  },

  methods: {
    ...mapActions('models/conceptPaymentTypes', ['fetchConceptPaymentTypes']),
  },

  mounted() {
    if (!this.conceptPaymentTypes.length) {
      this.fetchConceptPaymentTypes();
    }
  },
};
